import React from 'react';
import { Siren } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const RapidResponseAlert = ({ alert, onClose }) => {
  if (!alert) return null;
  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4" data-testid="rapid-response-alert">
      <div className="bg-white rounded-2xl max-w-lg w-full shadow-2xl overflow-hidden">
        <div className="bg-red-700 text-white p-4 flex items-center gap-3">
          <Siren className="w-7 h-7 animate-pulse" />
          <h3 className="text-lg font-bold">Rapid Response Activated</h3>
        </div>
        <div className="p-5 space-y-3">
          <p className="text-slate-800" data-testid="rapid-response-message">{alert.message}</p>
          <ul className="text-sm text-slate-700 list-disc pl-5 space-y-1">
            <li>Stay with the patient and maintain airway, breathing, and circulation.</li>
            <li>Raise the head of bed, apply oxygen, and obtain a full set of vitals.</li>
            <li>Give the team an SBAR report and review the orders you missed.</li>
          </ul>
          <Button onClick={onClose} className="w-full bg-red-700 hover:bg-red-800 text-white" data-testid="rapid-response-close-btn">
            I understand
          </Button>
        </div>
      </div>
    </div>
  );
};
